import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from '@sainsburys-tech/boltui-utils';
import { InsuranceIcon } from '@sainsburys-tech/bolt-icons';
import ProductCareItem from './components/ProductCareItem/ProductCareItem';
import ProductCareContent from './components/ProductCareContent/ProductCareContent';
import ProductCareFooter from './components/ProductCareFooter/ProductCareFooter';
import CareAdded from './components/CareAdded/CareAdded';
import Analytics from './ProductCareTracking';
import * as Styled from './ProductCare.styles';

var ProductCare = function ProductCare(_ref) {
  var analytics = _ref.analytics,
      addedWarranty = _ref.addedWarranty,
      onAddToTrolley = _ref.onAddToTrolley,
      quantity = _ref.quantity,
      hostPartNumber = _ref.hostPartNumber,
      hostProductName = _ref.hostProductName,
      hostPrice = _ref.hostPrice,
      children = _ref.children,
      dataTest = _ref['data-test'];

  var handleRemove = function handleRemove(warranty) {
    if (onAddToTrolley) onAddToTrolley(false, warranty);

    var analyticsData = _objectSpread(_objectSpread({}, analytics), {}, {
      quantity: quantity,
      hostPartNumber: hostPartNumber,
      hostPrice: hostPrice,
      warrantyPartNumber: warranty.partnumber,
      warrantyPrice: warranty.price
    });

    Analytics.onProductCareRemoveFromTrolley(analyticsData, window);
  };

  if (addedWarranty && !isEmpty(addedWarranty)) {
    return /*#__PURE__*/React.createElement(Styled.ProductCareContainer, {
      "data-test": dataTest
    }, /*#__PURE__*/React.createElement(CareAdded, {
      title: addedWarranty.name,
      price: addedWarranty.price,
      totalPrice: addedWarranty.price * quantity || 0,
      quantity: quantity,
      onRemove: function onRemove() {
        return handleRemove(addedWarranty);
      },
      "data-test": dataTest
    }));
  }

  var renderChildren = function renderChildren() {
    return React.Children.toArray(children).map(function (child, index) {
      return /*#__PURE__*/React.cloneElement(child, {
        analytics: analytics,
        onAddToTrolley: onAddToTrolley,
        quantity: quantity,
        hostPartNumber: hostPartNumber,
        hostPrice: hostPrice,
        hostProductName: hostProductName,
        'data-test': child.props['data-test'] || "".concat(dataTest, "-item-").concat(index)
      });
    });
  };

  return /*#__PURE__*/React.createElement(Styled.ProductCareContainer, {
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(Styled.ProductCareTitle, null, /*#__PURE__*/React.createElement(InsuranceIcon, {
    height: "20px",
    width: "20px",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("strong", null, "Protect your product today with Argos Care")), renderChildren());
};

ProductCare.propTypes = {
  /**
   * The warranty item that has been added to the user's basket
   */
  addedWarranty: PropTypes.shape({
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    partnumber: PropTypes.string.isRequired
  }),

  /**
   * Callback function which is called when user clicks the CTA
   */
  onAddToTrolley: PropTypes.func.isRequired,

  /**
   * The quantity of the "host product" - the product the user is buying warranty for
   */
  quantity: PropTypes.number,

  /**
   * The part number of the "host product" - the product the user is buying warranty for
   */
  hostPartNumber: PropTypes.string.isRequired,

  /**
   * The product name  of the "host product" - the product the user is buying warranty for
   */
  hostProductName: PropTypes.string.isRequired,

  /**
   * The price of the "host product" - the product the user is buying warranty for
   */
  hostPrice: PropTypes.number.isRequired,

  /**
   * Specify an optional data-test attribute to be added for e2e testing
   */
  'data-test': PropTypes.string,

  /**
   * Analytics data. Can disable specific tracking events.
   */
  analytics: PropTypes.shape({
    pageName: PropTypes.string,
    clickOrigin: PropTypes.string,
    monthlyPageName: PropTypes.string,
    monthlyClickOrigin: PropTypes.string,
    shouldTrackTermsAndConditions: PropTypes.bool,
    shouldTrackAddToTrolley: PropTypes.bool,
    shouldTrackCloseModal: PropTypes.bool,
    shouldTrackRemoveFromTrolley: PropTypes.bool,
    itemIndex: PropTypes.number,
    pageIdentifier: PropTypes.string
  })
};
ProductCare.defaultProps = {
  addedWarranty: {},
  quantity: 1,
  'data-test': 'product-care',
  analytics: {
    shouldTrackTermsAndConditions: true,
    shouldTrackAddToTrolley: true,
    shouldTrackCloseModal: true,
    shouldTrackRemoveFromTrolley: true
  }
};
ProductCare.ProductCareItem = ProductCareItem;
ProductCare.ProductCareContent = ProductCareContent;
ProductCare.ProductCareFooter = ProductCareFooter;
export default ProductCare;